export enum CtaWidthEnum {
  Auto = 'auto',
  Fix = 'fix',
  Square = 'square',
  Full = 'full',
  Responsive = 'responsive',
  IconOnly = 'icon-only',
}
